<template>
    <div class="part">
        <side-bar></side-bar>
        <div class="part_container">
            <m-header></m-header>
            <main-page></main-page>
        </div>
    </div>
</template>

<script>
import SideBar from './sideBar'
import MHeader from './headers.vue'
import MainPage from './main-page.vue'
export default {
  components: {
    SideBar,
    MHeader,
    MainPage
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?26b5a9ba